<template>
    <v-row justify="center">
        <v-col class="link-or-register-member" lg="6" md="6" sm="10">
            <h1>{{title}}</h1>

            <v-col>
                <p>No ASCA Membership? Sign up now to gain more perks.</p>
                <v-btn @click="onRegister">JOIN</v-btn>
            </v-col>

            <a @click="onSkip">Skip for now</a>

            <div class="footer-container">
                <v-img height="2rem" contain :src="logoImage" />
                <footer-text />
            </div>
        </v-col>
    </v-row>
</template>

<script lang="ts">
import Vue from 'vue';
import FooterText from '@/components/common/FooterText.vue';
import userService from '@/services/portal/userService';
import { reportError } from '@/services/errorHandler';

const logoImage = require('@/assets/logo.svg');

export default Vue.extend({
    components: { FooterText },
    name: 'LinkOrRegister',
    data() {
        const agreementFor = this.$store.state.agreementFor;

        let title;

        switch (agreementFor) {
            case "New Account":
                title = "Thank you for creating your ASCA web account."
                break;
            default:
                title = "Gain more perks with an ASCA Membership!"
                break;
        }

        return { title, logoImage };
    },
    methods: {
        async onSkip() {
            try {
                await userService.setPromptedForMembershipAt()
            } catch (error) {
                reportError(error);
            }

            this.$navigate('/dogs/');
        },
        async onRegister() {
            try {
                await userService.setPromptedForMembershipAt()
            } catch (error) {
                reportError(error);
            }

            this.$navigate('/registration/member');
        }
    }
});
</script>
